import React from "react";
import { X } from "lucide-react";

export const ActiveFilters = ({ searchQuery, projectIdFilter, energyLabelFilter, onClear }) => {
  const hasFilters = searchQuery || projectIdFilter || energyLabelFilter;
  
  if (!hasFilters) return null;

  return (
    <div className="bg-blue-50 text-blue-700 border border-blue-200 p-4 rounded-md mb-6">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-semibold text-blue-800 text-sm">Active filters:</span>
        {searchQuery && (
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium">
            Name: {searchQuery}
          </span>
        )}
        {projectIdFilter && (
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium">
            ID: {projectIdFilter}
          </span>
        )}
        {energyLabelFilter && (
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium">
            Energy: {energyLabelFilter}
          </span>
        )}
        <button
          onClick={onClear}
          className="ml-2 text-blue-600 hover:text-blue-800 transition-colors duration-200"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};